import { ContainerGrid } from "src/components";
import { TeamOverviewSection } from "src/constants";
import { useTeamPageLayoutContext } from "..";
import { useSettings } from "../../../hooks";
import { TeamAbout, TeamFeed, TeamNetwork, TeamStatisticsSummary } from "./components";

const TeamOverviewPage = () => {
  const { team } = useTeamPageLayoutContext();
  const { teamOverviewSettings } = useSettings();
  const isSectionExpanded = teamOverviewSettings.expandedSection !== undefined;

  return (
    <ContainerGrid container spacing={{ xs: 0.75, md: 1 }}>
      <ContainerGrid size={{ lg: isSectionExpanded ? 8 : 12 }} offset={{ lg: isSectionExpanded ? 2 : 0 }}>
        <TeamStatisticsSummary />
      </ContainerGrid>
      <ContainerGrid
        size={{
          xs: 12,
          md: isSectionExpanded ? 12 : 4,
          lg: isSectionExpanded ? 8 : 4,
        }}
        offset={{
          lg: isSectionExpanded ? 2 : 0,
        }}
        sx={{
          maxHeight: isSectionExpanded ? "720px" : "unset",
        }}
      >
        {teamOverviewSettings.expandedSection === undefined ||
        teamOverviewSettings.expandedSection === TeamOverviewSection.Feed ? (
          <TeamFeed sx={{ height: "100%", display: "flex", flexDirection: "column" }} />
        ) : teamOverviewSettings.expandedSection === TeamOverviewSection.About ? (
          <TeamAbout sx={{ height: "100%", display: "flex", flexDirection: "column" }} />
        ) : (
          <TeamNetwork teamSlug={team.slug} sx={{ height: "100%", display: "flex", flexDirection: "column" }} />
        )}
      </ContainerGrid>
      <ContainerGrid
        size={{
          xs: 12,
          md: isSectionExpanded ? 6 : 4,
          lg: isSectionExpanded ? 4 : 4,
        }}
        offset={{ lg: isSectionExpanded ? 2 : 0 }}
      >
        {teamOverviewSettings.expandedSection === undefined ||
        teamOverviewSettings.expandedSection === TeamOverviewSection.Feed ? (
          <TeamAbout />
        ) : (
          <TeamFeed />
        )}
      </ContainerGrid>
      <ContainerGrid
        size={{
          xs: 12,
          md: isSectionExpanded ? 6 : 4,
          lg: isSectionExpanded ? 4 : 4,
        }}
      >
        {teamOverviewSettings.expandedSection !== TeamOverviewSection.Network ? (
          <TeamNetwork teamSlug={team.slug} />
        ) : (
          <TeamAbout />
        )}
      </ContainerGrid>
    </ContainerGrid>
  );
};

export { TeamOverviewPage };
